export function saveDarkMode() {
    if (dotvvm.viewModels.root.viewModel.IsDarkModeEnabled()) {
        document.cookie = "dark-mode=true; path=/"
    }
    else {
        document.cookie = "dark-mode=false; path=/"
    }
}

export function updateTwitterTheme() {

    const parent = document.querySelector(".panel__timeline")

    if (parent) {
        let theme = 'light'
        if (dotvvm.viewModels.root.viewModel.IsDarkModeEnabled()) {
            theme = 'dark'
        }

        const button = document.createElement('a')
        button.innerHTML = "Tweets by update_conf"
        button.setAttribute("data-chrome", 'nofooter noborders')
        button.setAttribute('data-theme', theme)
        button.setAttribute('hidden', 'true')
        button.setAttribute("href", dotvvm.viewModels.root.viewModel.TwitterHtml())

        const oldIframe = parent.getElementsByTagName('iframe')[0]
        parent.appendChild(button)
        parent.removeChild(oldIframe)
    }
}